export default __webpack_public_path__ + "static/unique-sessions-light-mode-5c0470635556f19a216464877397bc2d.png";